import { Drawer } from 'antd'

import { drawerAndModalWidth } from '../../../../util/guideline'
import { BankingGroup } from '../models'
import { UpdateBankingGroupRating } from './UpdateBankingGroupRating'

interface UpdateBankingGroupRatingDrawerProps {
  group: BankingGroup
  isVisible: boolean
  onClose: () => void
  onSuccess: () => void
}

export const UpdateBankingGroupRatingDrawer = ({
  group,
  isVisible,
  onClose,
  onSuccess,
}: UpdateBankingGroupRatingDrawerProps) => (
  <Drawer
    title="Update Banking Group Rating"
    placement="right"
    open={isVisible}
    onClose={onClose}
    width={drawerAndModalWidth}
    destroyOnClose
  >
    <UpdateBankingGroupRating group={group} onSuccess={onSuccess} />
  </Drawer>
)
